import React, {useState} from "react";
import { useJobData } from "../../hooks/useJobData";
import Form from "./Form";
import {getDataFresh, getDepartmentsData, getKeysData} from "../../state/selectors";
import { useSelector } from "react-redux";
import {useDefaultsData} from "../../hooks/useDefaultsData";
import {useDepartmentsData} from "../../hooks/useDepartmentsData";
import {useFittersData} from "../../hooks/useFittersData";
import {useKeysData} from "../../hooks/useKeysData";
import {useWorkTypeData} from "../../hooks/useWorkTypeData";
import {useMovementsRateData} from "../../hooks/useMovementsRateData";
import {useMovementTypesData} from "../../hooks/useMovementTypesData";
import {useDriversData} from "../../hooks/useDriversData";
import {useTrackingOptionsData} from "../../hooks/useTrackingOptionsData";
import {useUtilData} from "../../hooks/useUtilData";
import useDefaultWorkLookupData from "../../hooks/useDefaultWorkLookupData";

function JobForm(props) {
  let dataFresh = useSelector(getDataFresh);
  let app_defaults_loaded = useDefaultsData({});
  let job_loaded = useJobData(props.match.params.job, dataFresh);
  const [utilsParam, setUtilsParam] = useState({department: 1, key: 1, work_type: 1, movement_rate: 1, movement_type: 1, driver: 1, tracking: 1, fitter: 1})
  let utilsLoaded = useUtilData(utilsParam);
  let defaultWorkLoaded = useDefaultWorkLookupData({});
  //let departmentsLoaded = useDepartmentsData({});
  //let keys_loaded = useKeysData({});
  //let workTypesLoaded = useWorkTypeData({})
  //let movementRatesLoaded = useMovementsRateData({});
  //let movementTypesLoaded = useMovementTypesData({});
  //let driversLoaded = useDriversData({});
  //let trackingOptionsLoaded = useTrackingOptionsData({});
  //const fittersLoaded = useFittersData({page_size:1000})

  //loaded={job_loaded && departmentsLoaded && fittersLoaded && keys_loaded && workTypesLoaded && movementRatesLoaded && movementTypesLoaded && driversLoaded && trackingOptionsLoaded}
  return (
    <Form
      loaded={job_loaded && utilsLoaded && app_defaults_loaded && defaultWorkLoaded}
      endpoint={props.endpoint}
      history={props.history}
      utilsParam={utilsParam}
      setUtilsParam={setUtilsParam}
    />
  );
}

export default JobForm;
